import { render } from "./IdChip.vue?vue&type=template&id=3f006fa7"
import script from "./IdChip.vue?vue&type=script&lang=js"
export * from "./IdChip.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__